import React, { useEffect } from "react";
import "./termAndCondition.css";
import Meta from "utils/meta";

const TermAndCondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div className="container">
      <Meta title="Term And Condition | The Realtor Desk" description="" />
      <div className="termCondition-container">
        <div className="termCondition-heading">
          <h1>Term of Services</h1>
        </div>
        <div className="termCondition-content">
          <p>Thanks for using our products and services (“Services”).</p>
          <p>
            By using our Services, you are agreeing to these terms. Please read
            them carefully.
          </p>
          <p>
            Our Services are very diverse, so sometimes additional terms or
            product requirements (including age requirements) may apply.
            Additional terms will be available with the relevant Services, and
            those additional terms become part of your agreement with us if you
            use those Services.
          </p>

          <h3>YOUR AGREEMENT WITH The Realtor Desk</h3>
          <p>
            The Realtor Desk is internet based software applications (“Internet
            Based Software”).
          </p>
          <p>
            1.1 Any additional products or features of the The Realtor Desk
            Software, or other “ The Realtor Desk” branded products, that you
            pay for (including products or features available for free on a
            trial basis only) (“Paid For Products”) are provided to you by The
            Realtor Desk
          </p>
          <p>
            1.2 “ The Realtor Desk Websites” means www.therealtordesk.com. and
            any other websites authorised by The Realtor Desk which link to
            these Terms.
          </p>
          <p>1.3 “ The Realtor Desk’’ means The Realtor Desk Software;</p>
          <p>
            1.4 “Products” means collectively the Free Products and Paid For
            Products;
          </p>
          <p>
            1.5 “data" means the quantities, characters, or symbols on which
            operations are performed by a computer. Any file (like image etc) is
            not considered as data here;
          </p>
          <p>
            1.6 “you” or “your” means you, the registered holder of the User
            Account and licensee under these Terms.
          </p>
          <p>
            1.7 "subscription registrations" or "subscription" means User
            Account and licensee under these Terms.
          </p>

          <h3>MODIFICATION OF TERMS OF SERVICES</h3>
          <p>
            We may modify the Terms upon notice to you at any time through a
            service announcement or by sending email to your primary email
            address. If we make significant changes to the Terms that affect
            your rights, you will be provided with at least 30 days advance
            notice of the changes by email to your primary email address. You
            may terminate your use of the Services by providing The Realtor Desk
            notice by email within 30 days of being notified of the availability
            of the modified Terms if the Terms are modified in a manner that
            substantially affects your rights in connection with use of the
            Services.
          </p>

          <h3>MODIFICATION AND IMPROVEMENT</h3>
          <p>
            The Realtor Desk is constantly improving the Software and Products
            and may change them at any time. Additionally, there are reasons why
            The Realtor Desk may stop providing the Software and Products (or
            portions thereof) including (without limitation) that it is no
            longer feasible for us to provide it, the technology advances,
            customer feedback indicates a change is needed, external issues
            arise that make it imprudent or impractical to continue, or any
            reason, you may need to use an upgraded version of the Software.
            Technical requirements for use of Products and Software and feature
            descriptions are available on the The Realtor Desk Website. If you
            do not agree with any changes to Software and Products you may
            terminate your relationship with The Realtor Desk. You may need to
            upgrade to a new version in order to enjoy the benefit of certain
            Products. In addition, you acknowledge and agree that certain
            Products may be subject to usage limits or geographical
            restrictions, which may vary from time to time.
          </p>

          <h3>3RD PARTY CO-ORDINATION OR INTERACTION</h3>
          <p>
            The Realtor Desk is not responsible for any 3rd party co-ordination
            and also not be responsible for any business loss.
          </p>

          <h3>EXPIRY, RENEWAL & DATA DELETION POLICIES</h3>
          <p>
            In order to best assist you with the renewal of your subscription,
            we will send you multiple e-mail reminders and notifications to your
            primary email address (Your administrative contact information for
            the applicable subscription), both before and after your
            subscription’s expiration date.
          </p>
          <p>
            In an effort to help you avoid the unintentional deletion of your
            subscription registrations, we may provide you with a “Renewal Grace
            Period.” A Renewal Grace Period will be 30 days from day after the
            subscription registration’s expiration date. During the Renewal
            Grace Period, your "data" will be remain same but your account will
            be blocked automatically. You may renew your subscription
            registration at any time during the Renewal Grace Period and unblock
            or resume your account.
          </p>
          <p>
            If an expired subscription registrations is not renewed after
            Renewal Grace Period, you are agree to delete your all "data" from
            our database record without any notice and after that no "data"
            recovery/claim/backup will be accepted. we advise you to renew your
            subscription within “Renewal Grace Period.”
          </p>

          <h3>EMAIL AND SMS SERVICES</h3>
          <p>
            The Realtor Desk does not offer any email or sms services and also
            does not responsible for any legal matter. Customer should be
            responsible to buy his/her own email and sms services based on their
            term and condition. The Realtor Desk is not responsible for any
            issue related to unsubscribe /virus/dnd/spam/junk in email or sms
          </p>

          <h3>BACKUP, RECOVERY AND DOWNLOAD DATA</h3>
          <p>
            Our backup services are ran on everyday and take 'data' backup
            (except images and files) and we kept ONE MONTH for backups to
            enhanced your data security and avoid any data loss or audit purpose
            only. This service is provided to you as a courtesy.
          </p>
          <p>
            You can download or export your data at any time from your The
            Realtor Desk user account as per given format.
          </p>
          <p>
            The Realtor Desk is not offering any backup or recovery feature for
            images or files residing on your account.
          </p>

          <h3>DATA OWNERSHIP</h3>
          <p>
            The Realtor Desk allow you to submit content. You retain ownership
            of any intellectual property rights that you hold in that content.
            When you upload or otherwise submit content to our Services, you
            give The Realtor Desk (and those we work with) a worldwide license
            to store, modify, create derivative works (such as those resulting
            from translations, adaptations or other changes we make so that your
            content works better with our Services for you).
          </p>
          <p>
            Your use of the Services does not grant The Realtor Desk the license
            to use, reproduce, adapt, modify, publish or distribute the content
            created by you or stored in your user account for The Realtor Desk’s
            commercial, marketing or any similar purpose.
          </p>

          <h3>USER GENERATED CONTENT</h3>
          <p>
            You may transmit or publish content created by you using any of the
            Services or otherwise. However, you shall be solely responsible for
            such content and the consequences of its transmission or
            publication. Any content made public will be publicly accessible
            through the internet and may be crawled and indexed by search
            engines. You are responsible for ensuring that you do not
            accidentally make any private content publicly available. Any
            content that you may receive from other users of the Services, is
            provided to you AS IS for your information and personal use only and
            you agree not to use, copy, reproduce, distribute, transmit,
            broadcast, display, sell, license or otherwise exploit such content
            for any purpose, without the express written consent of the person
            who owns the rights to such content Further, by making any content
            available in the manner aforementioned, you expressly agree that The
            Realtor Desk will have the right to block access to or remove such
            content made available by you if The Realtor Desk receives
            complaints concerning any illegality or infringement of third party
            rights in such content. By using any of the Services and
            transmitting or publishing any content using such Service, you
            expressly consent to determination of questions of illegality or
            infringement of third party rights in such content by the agent
            designated by The Realtor Desk for this purpose.
          </p>

          <h3>YOUR OBLIGATIONS</h3>
          <p>
            User Account. Prior to your first use of the The Realtor Desk
            Software, you will be asked to register a User Account and choose a
            username(email address). You are solely responsible and liable for
            all activities conducted through your User Account. To prevent
            unauthorised use, you shall keep your password confidential and
            shall not share it with any third party or use it to access third
            party websites or services. If you suspect that someone else knows
            your password, then you shall immediately change it in order to
            protect the security of your User Account. It is your responsibility
            to ensure that you do not respond to any unsolicited requests. The
            Realtor Desk takes no responsibility for your failure to comply with
            the obligations.
          </p>
          <p>
            Lawful Use. You must use the Software, Products and The Realtor Desk
            Websites in accordance with the laws of where you are located. There
            may be certain legal and other restrictions on the download and use
            of the Software, Products and/or The Realtor Desk Websites. It is
            your responsibility to ensure that you are legally allowed to use
            the Software, Products and/or The Realtor Desk Websites.
          </p>
          <p>
            No Reselling. The Software and Products are for your individual use.
            You shall not resell or transfer or commercialise the Software
            and/or Products to any third party.
          </p>

          <h3>REFUND POLICY</h3>
          <p>
            If you believe that The Realtor Desk has charged you in error, you
            must contact The Realtor Desk within 7 days of such charge. No
            refunds will be given for any charges more than 7 days old. The
            Realtor Desk reserves the right to refuse a refund request if it
            reasonably believes (i) that you are trying to unfairly exploit this
            refund policy, for example, by making repetitive refund requests in
            respect of the same Product; (ii) if you are in breach of these
            Terms or (iii) if The Realtor Desk reasonably suspects that you are
            using our Products or Software fraudulently or that your User
            Account is being used by a third party fraudulently.
          </p>

          <h3>OUR WARRANTIES AND DISCLAIMERS</h3>
          <p>
            YOU EXPRESSLY UNDERSTAND AND AGREE THAT THE USE OF THE SERVICES IS
            AT YOUR SOLE RISK. THE SERVICES ARE PROVIDED ON AN
            AS-IS-AND-AS-AVAILABLE BASIS. The Realtor Desk EXPRESSLY DISCLAIMS
            ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING,
            BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
            FITNESS FOR A PARTICULAR PURPOSE. The Realtor Desk MAKES NO WARRANTY
            THAT THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR
            FREE. USE OF ANY MATERIAL DOWNLOADED OR OBTAINED THROUGH THE USE OF
            THE SERVICES SHALL BE AT YOUR OWN DISCRETION AND RISK AND YOU WILL
            BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM, MOBILE
            TELEPHONE, WIRELESS DEVICE OR DATA THAT RESULTS FROM THE USE OF THE
            SERVICES OR THE DOWNLOAD OF ANY SUCH MATERIAL. NO ADVICE OR
            INFORMATION, WHETHER WRITTEN OR ORAL, OBTAINED BY YOU FROM The
            Realtor Desk, ITS EMPLOYEES OR REPRESENTATIVES SHALL CREATE ANY
            WARRANTY NOT EXPRESSLY STATED IN THE TERMS
          </p>

          <h3>LIABILITY FOR OUR SERVICES</h3>
          <p>
            YOU AGREE THAT The Realtor Desk SHALL, IN NO EVENT, BE LIABLE FOR
            ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, SPECIAL, PUNITIVE, OR OTHER
            LOSS OR DAMAGE WHATSOEVER OR FOR LOSS OF BUSINESS PROFITS, BUSINESS
            INTERRUPTION, COMPUTER FAILURE, LOSS OF BUSINESS INFORMATION, OR
            OTHER LOSS ARISING OUT OF OR CAUSED BY YOUR USE OF OR INABILITY TO
            USE THE SERVICE, EVEN IF The Realtor Desk HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGE. IN NO EVENT SHALL The Realtor Desk’S
            ENTIRE LIABILITY TO YOU IN RESPECT OF ANY SERVICE, WHETHER DIRECT OR
            INDIRECT, EXCEED THE FEES PAID BY YOU TOWARDS SUCH SERVICE.
          </p>

          <h3>SUSPENSION AND TERMINATION</h3>
          <p>
            We may suspend your user account or temporarily disable access to
            whole or part of any Service in the event of any suspected illegal
            activity, extended periods of inactivity or requests by law
            enforcement or other government agencies. Objections to suspension
            or disabling of user accounts should be made to therealtordesk.com
            within thirty days of being notified about the suspension. We may
            terminate a suspended or disabled user account after thirty days. We
            will also terminate your user account on your request.
          </p>
          <p>
            In addition, we reserve the right to terminate your user account and
            deny the Services upon reasonable belief that you have violated the
            Terms and to terminate your access to any our Service in case of
            unexpected technical issues or discontinuation of the our Service.
            You have the right to terminate your user account if The Realtor
            Desk breaches its obligations under these Terms and in such event.
            Termination of user account will include denial of access to all
            Services, deletion of information in your user account such as your
            email address and password and deletion of all data in your user
            account.
          </p>

          <h3>ARBITRATION</h3>
          <p>
            Any controversy or claim shall be arbitrated on an individual basis,
            and shall not be consolidated in any arbitration with any claim or
            controversy of any other party. The decision of the arbitrator shall
            be final and unappealable. The arbitration shall be conducted in
            Allahabad and judgment on the arbitration award may be entered into
            any court having jurisdiction thereof. Notwithstanding anything to
            the contrary, The Realtor Desk may at any time seek injunctions or
            other forms of equitable relief from any court of competent
            jurisdiction.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermAndCondition;
